const MARCA_BASE = 'https://public-assets.redefrota.com.br/img';

const APP_BASE = `${MARCA_BASE}/frotabank/v1`;

export const ASSETS = {
  dicaCelularChat: `${APP_BASE}/indique-celular-chat.png`,
  dicaNuvemDownload: `${APP_BASE}/indique-nuvem-download.png`,
  dicaCartaoDinheiro: `${APP_BASE}/indique-cartao-dinheiro.png`,
};
